const toHyphenCase = str => str.replace(/ /g, "-").toLowerCase();

const isPastDate = date => new Date(date) < new Date();

module.exports = {
  toHyphenCase,
  isPastDate
};